export const DEFAULT_BANNER_TYPE_QUESTION_TYPES = new Set([
  'acknowledgement',
  'acknowledgment',
  'text_message',
  'warning',
  'info',
  'error',
  'information',
]);

export const DEFAULT_TEXT_QUESTION_TYPES = new Set([
  'text',
  'text_area',
  'integer',
  'decimal',
  'email',
  'phone',
  'url',
]);

export const TextInputTypeMapper = new Map<
  string,
  'number' | 'text' | 'password'
>([
  ['integer', 'number'],
  ['decimal', 'number'],
  ['text', 'text'],
  ['email', 'text'],
  ['phone', 'text'],
  ['url', 'text'],
]);

export const ChoiceInputTypeMapper = new Map<
  string,
  'dropdown' | 'radio' | 'choice' | 'multi_choice'
>([
  ['dropdown', 'dropdown'],
  ['multi_choice', 'multi_choice'],
  ['choice', 'choice'],
  ['radio', 'radio'],
]);

export const STATE_TITLES = new Set<string>([
  'state/province:',
  'province',
  'state',
  'state/province',
  'states',
]);
